import service from 'common/service';
import { atom, useAtom } from 'jotai';
import { useQuery } from '@tanstack/react-query';
import { ProjectRolePermission } from 'common/types';
import { FastApiStatusCode } from 'common/service/constants/fastApi';

export const platformPermissionAtom = atom<string[]>([]);
export const projectPermissionAtom = atom<ProjectRolePermission>({});

export const usePermission = () => {
  const [platformPermission, setPlatformPermission] = useAtom(platformPermissionAtom);
  const [currentProjectPermission, setCurrentProjectPermission] = useAtom(projectPermissionAtom);

  const getPlatformPermissionQuery = useQuery({
    enabled: false,
    queryKey: ['getPlatformPermission'],
    queryFn: async () => {
      try {
        const res = await service.userSetting.getPlatformPermission();
        if (res.code === FastApiStatusCode.SuccessCode) {
          setPlatformPermission(res.data);
          return res.data;
        } else {
          return [];
        }
      } catch (error) {}
    },
  });

  return {
    platformPermission,
    setPlatformPermission,
    currentProjectPermission,
    setCurrentProjectPermission,
    getPlatformPermissionQuery,
  };
};
